import { makeNiceName, retrieveApplianceNetworkName } from '../../lib/helpers';
import { AZURE_TYPES, CLOUD_TYPE, VSPHERE_TYPES } from '../../constants';

/**
 * Helpers function that will return ad hoc appliance properties for each target cloud.
 */

let convertToFlatNetworkProperties = (appliance) => {
    let target = $.extend(true, {}, appliance);
    let network = target.cloud_properties?.network;
    let ip_type = network.interfaces.eth0.ip_type;

    target.cloud_properties.network_ip_type = makeNiceName(ip_type, true);
    target.cloud_properties.network_name = retrieveApplianceNetworkName(target);

    if (ip_type === 'static') {
        target.cloud_properties.gateway = network.interfaces.eth0.netmask;
        if (network.hasOwnProperty('routes')) {
            target.cloud_properties.gateway = network.routes.default_gateway;
        }
        if (network.hasOwnProperty('dns')) {
            target.cloud_properties.primary_dns = network.dns.primary;
            target.cloud_properties.secondary_dns = network.dns.secondary;
        }
    }

    delete target.cloud_properties.network;
    return target;
};

export const appliancePropertiesConfig = {
    [CLOUD_TYPE.VSPHERE]: {
        getApplianceProperties(appliance) {
            return {};
        },
    },
    [VSPHERE_TYPES.VSPHERE_DR]: {
        getApplianceProperties(appliance) {
            return {};
        },
    },
    [VSPHERE_TYPES.VSPHERE_OFFLINE_REPLICAS]: {
        getApplianceProperties(appliance) {
            return {};
        },
    },
    [CLOUD_TYPE.AWS]: {
        getApplianceProperties(appliance) {
            let properties = convertToFlatNetworkProperties(appliance).cloud_properties;
            properties.availability_zone = properties.az;
            properties.subnet = properties.network_name;
            properties.instance_name = properties.vapp_name;
            delete properties.vapp_name;
            delete properties.network_name;
            delete properties.network_ip_type;
            delete properties.az;

            return properties;
        },
    },
    [CLOUD_TYPE.AZURE]: {
        getApplianceProperties(appliance) {
            let properties = convertToFlatNetworkProperties(appliance).cloud_properties;
            properties.subnet = properties.network_name;
            properties.vm_name = properties.vapp_name;
            properties.virtual_network = `${properties.virtual_network.name} | ${properties.virtual_network.resource_group}`;

            delete properties.network_name;
            delete properties.network_ip_type;
            delete properties.vapp_name;
            return properties;
        },
    },
    [CLOUD_TYPE.AZURE_LOCAL]: {
        getApplianceProperties(appliance) {
            let properties = convertToFlatNetworkProperties(appliance).cloud_properties;
            properties.subnet = properties.network_name;
            properties.vm_name = properties.vapp_name;
            properties.virtual_network = `${properties.virtual_network.name} | ${properties.virtual_network.resource_group}`;

            delete properties.network_name;
            delete properties.network_ip_type;
            delete properties.vapp_name;
            return properties;
        },
    },
    [AZURE_TYPES.AZURE_DR]: {
        getApplianceProperties(appliance) {
            return {};
        },
    },
    [CLOUD_TYPE.OPENSHIFT]: {
        getApplianceProperties(appliance) {
            return {};
        },
    },
    [CLOUD_TYPE.OPENSTACK]: {
        getApplianceProperties(appliance) {
            return {};
        },
    },
    [CLOUD_TYPE.NC2]: {
        getApplianceProperties(appliance) {
            return {};
        },
    },
    [CLOUD_TYPE.HPE_VME]: {
        getApplianceProperties(appliance) {
            return {};
        },
    },
    [CLOUD_TYPE.GCP]: {
        getApplianceProperties(appliance) {
            let properties = convertToFlatNetworkProperties(appliance).cloud_properties;
            properties.zone = properties.az;
            properties.vm_name = properties.vapp_name;

            delete properties.az;
            delete properties.vapp_name;
            return properties;
        },
    },
    [CLOUD_TYPE.HYPERV]: {
        getApplianceProperties(appliance) {
            return {};
        },
    },
};
